export default {
    namespaced: true,

    state: {
        reCalculateDialogVisible: false,
        networkDiagnosticDialogVisible: false,
    },
    mutations: {
        updateReCalculateDialogVisible(state, _update) {
            state.reCalculateDialogVisible = _update;
        },
        updateNetworkDiagnosticDialogVisible(state, _update) {
            state.networkDiagnosticDialogVisible = _update;
        },
    },
};
